import { render } from "./EmployeeContactDetails.vue?vue&type=template&id=10274664&scoped=true"
import script from "./EmployeeContactDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeContactDetails.vue?vue&type=script&lang=js"

import "./EmployeeContactDetails.vue?vue&type=style&index=0&id=10274664&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10274664"]])

export default __exports__